<div
  class="frame-block {{ cssScopeClass }}"
  [ngStyle]="frameStyles()"
>
  <app-block-list [blockIdList]="body()"></app-block-list>
</div>
